"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerMachine = void 0;
const machineTypes_1 = require("./machineTypes");
exports.triggerMachine = {
    initial: machineTypes_1.MachineTypes.CLOSED,
    states: {
        [machineTypes_1.MachineTypes.CLOSED]: {
            on: {
                OPEN_CART: machineTypes_1.MachineTypes.OPEN_CART,
                OPEN_NEW_ITEM: machineTypes_1.MachineTypes.OPEN_NEW_ITEM,
                OPEN_NEW_LOYALTY: machineTypes_1.MachineTypes.OPEN_NEW_LOYALTY,
                OPEN_EMPTY: machineTypes_1.MachineTypes.OPEN_EMPTY,
                OPEN_ERROR: machineTypes_1.MachineTypes.OPEN_ERROR,
            },
        },
        [machineTypes_1.MachineTypes.OPEN_CART]: {
            on: {
                CLOSED: machineTypes_1.MachineTypes.CLOSED,
                OPEN_ERROR: machineTypes_1.MachineTypes.OPEN_ERROR,
            },
        },
        [machineTypes_1.MachineTypes.OPEN_NEW_ITEM]: {
            on: {
                CLOSED: machineTypes_1.MachineTypes.CLOSED,
                OPEN_NEW_LOYALTY: machineTypes_1.MachineTypes.OPEN_NEW_LOYALTY,
                OPEN_ERROR: machineTypes_1.MachineTypes.OPEN_ERROR,
            },
        },
        [machineTypes_1.MachineTypes.OPEN_NEW_LOYALTY]: {
            on: {
                CLOSED: machineTypes_1.MachineTypes.CLOSED,
                OPEN_NEW_ITEM: machineTypes_1.MachineTypes.OPEN_NEW_ITEM,
                OPEN_ERROR: machineTypes_1.MachineTypes.OPEN_ERROR,
            },
        },
        [machineTypes_1.MachineTypes.OPEN_EMPTY]: {
            on: {
                CLOSED: machineTypes_1.MachineTypes.CLOSED,
                OPEN_ERROR: machineTypes_1.MachineTypes.OPEN_ERROR,
            },
        },
        [machineTypes_1.MachineTypes.OPEN_ERROR]: {
            on: {
                CLOSED: machineTypes_1.MachineTypes.CLOSED,
            },
        },
    },
};
